import {Component, ElementRef, EventEmitter, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {US_Interactive} from "../../api/models/us_interactive";
import {US_ModifiedInteractive} from "../../api/models/us_modified-interactive";
import {UserState} from "../../api/models/user-state";
import {
  PowerBISettings, UdPreFilteredInteractiveFilters, US_PreFilterInteractives, PreFilter, US_PreFilter,
  PfkRegionState,
  PfkIndustrySector,
  PfkOccupationMajorGroup, InteractPoDPage, PodLayout, Users, PodLayoutEx, PodLayoutPage
} from '../../api/models';
import {Observable, Subscription, timer} from "rxjs";
import {PowerBIService} from "../../api/services/power-bi.service";
import {
  service as PbiService,
  Report as PbiReport,
  IEmbedConfiguration as PbiEmbedConfig,
  factories as PbiFactories,
  models as PbiModels
} from "powerbi-client"
import {GlobalApp} from "../../tools/global";
import {FilterService} from "./services/filter.service";
import {BookmarkService} from "./services/bookmark.service";
import {ReportService} from "./services/report.service";
import {Router} from "@angular/router";
import {InteractivesService} from "../../api/services/interactives.service";
import {MatDialog} from "@angular/material/dialog";
import {SubscriptionService} from "../../api/services/subscription.service";
import {MessageDialogComponent} from "../../dialogs/message-dialog/message-dialog.component";
import {
  CopyInteractiveDialogComponent,
  CopyInteractiveDialogData
} from "../../dialogs/copy-interactive-dialog/copy-interactive-dialog.component";
import {DialogResultType} from "../../dialogs/DialogResult";
import {ConfirmDialogComponent, ConfirmDialogData} from "../../dialogs/confirm-dialog/confirm-dialog.component";
import {
  InteractMenuDialogComponent,
  InteractMenuDialogData
} from "../../dialogs/interact-menu-dialog/interact-menu-dialog.component";
import {
  ShareInteractiveDialogComponent,
  ShareInteractiveDialogData
} from "../../dialogs/share-interactive-dialog/share-interactive-dialog.component";
import {UserStateEx} from "../../api/models-ex/user-state-ex";
import {UserTypeValue} from "../../api/models-ex/user-type-values";
import {PreFilterInteractivesService} from "../../api/services/pre-filter-interactives.service";
import {AdminInteractiveService, PreFilterService, PrintOnDemandService, SettingsService} from '../../api/services';
import { PfkLinkedinIndustry, PreFilterValuesService } from "../../services/pre-filter-values-service";
import {
  PrintOnDemandDialogComponent,
  PrintOnDemandDialogResult, PrintOnDemandFileType
} from '../../dialogs/print-on-demand-dialog/print-on-demand-dialog.component';
import {MatSnackBar} from '@angular/material/snack-bar';
import {PodStatusSnackbarComponent, PrintOnDemandData} from '../pod-status-snackbar/pod-status-snackbar.component';
import {
  PrintOnDemandLayoutDialogComponent,
  PrintOnDemandLayoutDialogResult
} from '../../dialogs/print-on-demand-layout-dialog/print-on-demand-layout-dialog.component';
import {ShareState} from '../share-editor/share-editor.component';

@Component({
  selector: 'app-powerbi-embed',
  templateUrl: './powerbi-embed.component.html',
  styleUrls: ['./powerbi-embed.component.css']
})
export class PowerbiEmbedComponent implements OnInit, OnDestroy {

  @Output() closeClicked = new EventEmitter();
  @ViewChild("pbiContainer") pbiContainer: ElementRef;
  @ViewChild("pbiTempContainer") pbiTempContainer: ElementRef;

  userId: number | null = null;
  interactId: string = null;
  interactType: string = null;
  actionType: string = null;
  filterId: string = null;
  bookmarkId: string = null;
  reportId: string = null;

  currentInteractive: US_Interactive = {
    interactId: 0,
    freeInteractive: false,
    canCopy: false,
    canModify: false,
    canPreFilter: false,
    preFilterTitleAvailable: false,
    preFilterCompanyAvailable: false,
    preFilterIndustryAvailable: false,
    preFilterOccupationAvailable: false,
    preFilterRegionAvailable: false,
    preFilters: [],
    isActive: false,
    allowPrintOnDemand: false
  };
  currentModifiedInteractive: US_ModifiedInteractive = null;
  //currentPreFilteredInteractive: US_PreFilterInteractives = null;

  public firstLoad: boolean = true;

  userState: UserState = {
    reportOnly: false,
    userManagerOnly: false,
    invoiceManagerOnly: false,
    interactives: [],
    modifiedInteractives: [],
    xmlas: [],
    preFilteredInteractives: [],
    reportExportState: {},
    isInteractiveUser: false,
    isReportExportUser: false,
    isEmbeddedUser: false
  };

  private powerBiClientService: PbiService.Service;
  private embeddedReport: PbiReport = null;
  private currentConfig: PbiEmbedConfig = null;

  public filterService: FilterService = null;
  public bookmarkService: BookmarkService = null;
  public reportService: ReportService = null;

  public availableInteractives: US_Interactive[] = [];
  public availableModifiedInteractives: US_ModifiedInteractive[] = [];
  public availablePreFilteredInteractives: US_PreFilterInteractives[] = [];

  public regionStateValues: PfkRegionState[] = [];
  public industryValues: PfkLinkedinIndustry[] = [];
  public occupationValues: PfkOccupationMajorGroup[] = [];

  public showCloseButton: boolean = false;

  reportSaving: boolean = false;
  doingSaveAs: boolean = false;

  editingLayout: boolean = false;

  public preFilterValues: any[];

  public availablePrintPages: InteractPoDPage[] = [];

  constructor(
    private app: GlobalApp,
    private powerbiService: PowerBIService,
    private router: Router,
    private interactiveService: InteractivesService,
    private preFilterInteractiveService: PreFilterInteractivesService,
    private dialog: MatDialog,
    private subscriptionService: SubscriptionService,
    private preFilterService: PreFilterService,
    private preFilterValueService: PreFilterValuesService,
    private adminInteractiveService: AdminInteractiveService,
    private printOnDemandService: PrintOnDemandService,
    private snackBar: MatSnackBar,
    private globalSettings: SettingsService
  ) {
    this.powerBiClientService = new PbiService.Service(
      PbiFactories.hpmFactory,
      PbiFactories.wpmpFactory,
      PbiFactories.routerFactory
    );
  }

  private embedTokenTimer: Observable<number>;
  private embedTokenSubscription: Subscription;
  private isSideNavigationEnabled: boolean = false;

  ngOnInit(): void {
    //this.embedTokenTimer = timer(60000, 60000 * 20);
    this.embedTokenTimer = timer(20000, 60000);
    this.embedTokenSubscription = this.embedTokenTimer.subscribe(t => {
      this.powerbiService.powerBIGetPowerBISettingsForInteractive(parseInt(this.interactId)).subscribe(results => {
        this.embeddedReport.config.embedUrl = results.embedUrl;
        this.embeddedReport.config.accessToken = results.accessToken;
        this.embeddedReport.configChanged(false);
      });
    });


  }

  ngOnDestroy() {
    this.embedTokenSubscription.unsubscribe();
    this.embedTokenTimer = null;
  }

  public loadPodLayout(layout: PodLayoutEx | undefined, interactId: number, userState: UserState) {
    this.editingLayout = true;

    this.userId = +this.app.getId();
    this.interactId = interactId.toString();
    this.interactType = "Interactive";
    this.actionType = "view";
    this.filterId = null;
    this.bookmarkId = null;
    this.reportId = null;
    this.userState = userState;
    this.showCloseButton = true;

    this.firstLoad = true;

    const interactiveId = this.loadUserState();

    this.podLayout = layout;

    this.loadInteractives();

    this.adminInteractiveService.adminInteractiveGetInteractivePrintOnDemandPages(parseInt(this.interactId, 10)).subscribe(result => {
      this.availablePrintPages = result;

      this.powerbiService.powerBIGetPowerBISettingsForInteractive(interactiveId).subscribe((powerBiSettingsResults) => {
        this.getInteractiveConfig(powerBiSettingsResults).then(currentConfig => {
          this.currentConfig = currentConfig;
          this.embeddedReport = this.powerBiClientService.embed(
            this.pbiContainer.nativeElement,
            this.currentConfig
          ) as PbiReport;

          this.app.pushLoading("Loading Interactive");

          this.loadServices();

          this.embeddedReport.on("rendered", (_) => {
            if (this.firstLoad) {
              window.setTimeout(() => {
                this.filterService.applyIfFilter(this.filterId);
                this.bookmarkService.applyIfBookmark(this.bookmarkId);
                this.reportService.applyIfReport(this.reportId);
                if (!this.podLayout) {
                  this.createLayout().then(_ => {});
                } else {
                  if (this.podLayout.bookmarkId) {
                    this.bookmarkService.applyIfBookmark(this.podLayout.bookmarkId.toString());
                    this.previewLayout(this.podLayout, UserStateEx.getPodLayoutShareState(this.userState, this.podLayout)).then(_ => {});
                  } else {
                    if (this.podLayout.bookmarkId) {
                      this.bookmarkService.applyBookmarkState(this.podLayout.bookmarkData).then(() => {
                        this.previewLayout(this.podLayout, UserStateEx.getPodLayoutShareState(this.userState, this.podLayout)).then(_ => {});
                      });
                    } else {
                      this.previewLayout(this.podLayout, UserStateEx.getPodLayoutShareState(this.userState, this.podLayout)).then(_ => {});
                    }
                  }
                }
                this.app.popLoading();
              }, 1000);
              this.firstLoad = false;
            }
          });

          this.embeddedReport.on(
            "pageChanged",
            (parameters: CustomEvent) => {
              const newPage = parameters.detail.newPage;

              this.interactiveService.interactivesLogNavigatedToInteractivePage({
                interactiveId: this.currentInteractive ? parseInt(this.interactId) : undefined,
                modifiedInteractiveId: this.currentModifiedInteractive ? parseInt(this.interactId) : undefined,
                preFilteredInteractiveId: undefined,
                interactivePage: newPage.name + " : " + newPage.displayName
              }).subscribe(_ => {
              })

            }
          );
        });
      });
    });
  }

  public loadInteractiveState(closeButton: boolean, userId: number, interactId: string, interactType: string, actionType: string, filterId: string, bookmarkId: string, reportId: string, userState: UserState) {
    this.userId = userId;
    this.interactId = interactId;
    this.interactType = interactType;
    this.actionType = actionType;
    this.filterId = filterId;
    this.bookmarkId = bookmarkId;
    this.reportId = reportId;
    this.userState = userState;
    this.showCloseButton = closeButton;

    this.firstLoad = true;

    const interactiveId = this.loadUserState();

    this.loadInteractives();

    this.adminInteractiveService.adminInteractiveGetInteractivePrintOnDemandPages(parseInt(this.interactId, 10)).subscribe(result => {
      this.availablePrintPages = result;

      let getSettingsObservable: Observable<PowerBISettings>;

      /*if (this.currentPreFilteredInteractive) {
        getSettingsObservable = this.powerbiService.powerBIGetPowerBISettingsForInteractive(
          this.currentPreFilteredInteractive.interactId
        )
      } else*/
      if (this.currentInteractive && this.currentInteractive.interactId !== 0) {
        getSettingsObservable = this.powerbiService.powerBIGetPowerBISettingsForInteractive(
          interactiveId
        );
      } else if (this.currentModifiedInteractive && this.currentModifiedInteractive) {
        getSettingsObservable = this.powerbiService.powerBIGetPowerBISettingsForModifiedInteractive(
          interactiveId
        );
      }

      getSettingsObservable.subscribe(
        (powerBiSettingsResults) => {
          if (this.actionType === "view") {
            if (this.currentInteractive /*|| this.currentPreFilteredInteractive*/) {

              this.getInteractiveConfig(powerBiSettingsResults).then(currentConfig => {
                this.currentConfig = currentConfig;
                this.embeddedReport = this.powerBiClientService.embed(
                  this.pbiContainer.nativeElement,
                  this.currentConfig
                ) as PbiReport;

                this.app.pushLoading("Loading Interactive");

                this.loadServices();

                this.embeddedReport.on("saved", (_) => {
                  this.reportSaved();
                });

                this.embeddedReport.on("rendered", (_) => {
                  if (this.firstLoad) {
                    window.setTimeout(() => {
                      this.filterService.applyIfFilter(this.filterId);
                      this.bookmarkService.applyIfBookmark(this.bookmarkId);
                      this.reportService.applyIfReport(this.reportId);
                      if (!this.userState.reportOnly) {
                        this.app.popLoading();
                      }

                    }, 1000);
                    this.firstLoad = false;
                  }
                });

                this.embeddedReport.on(
                  "pageChanged",
                  (parameters: CustomEvent) => {
                    const newPage = parameters.detail.newPage;

                    this.interactiveService.interactivesLogNavigatedToInteractivePage({
                      interactiveId: this.currentInteractive ? parseInt(this.interactId) : undefined,
                      modifiedInteractiveId: this.currentModifiedInteractive ? parseInt(this.interactId) : undefined,
                      preFilteredInteractiveId: undefined,
                      interactivePage: newPage.name + " : " + newPage.displayName
                    }).subscribe(_ => {
                    })

                    if (this.userState.reportOnly) {
                      if (
                        this.reportService.reportMainPage &&
                        newPage.name === this.reportService.reportMainPage.name
                      ) {
                        this.reportService.reportLastPage = newPage;
                        this.app.popLoading();
                      } else if (
                        newPage.displayName === "Home" &&
                        this.pbiContainer.nativeElement.style.display === "" &&
                        this.reportService.reportLastPage
                      ) {
                        this.embeddedReport.setPage(this.reportService.reportLastPage.name);
                      } else {
                        this.reportService.reportLastPage = newPage;
                      }
                    }
                  }
                );
              });
            } else if (this.currentModifiedInteractive) {
              this.currentConfig = {
                type: "report",
                id: powerBiSettingsResults.reportId,
                embedUrl: powerBiSettingsResults.embedUrl,
                accessToken: powerBiSettingsResults.accessToken,
                permissions: PbiModels.Permissions.Read,
                viewMode: PbiModels.ViewMode.View,
                settings: {
                  navContentPaneEnabled: true,
                  //bookmarksPaneEnabled: true,
                  bars: {
                    actionBar: {
                      visible: false,
                    },
                  },
                },
              };

              this.embeddedReport = this.powerBiClientService.embed(
                this.pbiContainer.nativeElement,
                this.currentConfig
              ) as PbiReport;

              this.app.pushLoading("Loading Interactive");

              this.loadServices();

              this.embeddedReport.on(
                "pageChanged",
                (parameters: CustomEvent) => {
                  const newPage = parameters.detail.newPage;

                  this.interactiveService.interactivesLogNavigatedToInteractivePage({
                    interactiveId: this.currentInteractive ? parseInt(this.interactId) : undefined,
                    modifiedInteractiveId: this.currentModifiedInteractive ? parseInt(this.interactId) : undefined,
                    interactivePage: newPage.name + " : " + newPage.displayName
                  }).subscribe(_ => {
                  })
                });

              this.embeddedReport.on("saved", (_) => {
                this.reportSaved();
              });

              this.embeddedReport.on("rendered", (_) => {
                if (this.firstLoad) {
                  window.setTimeout(() => {
                    this.filterService.applyIfFilter(this.filterId);
                    this.bookmarkService.applyIfBookmark(this.bookmarkId);
                    this.app.popLoading();
                  }, 1000);
                  this.firstLoad = false;
                }
              });
            }
          } else if (this.actionType === "edit") {
            if (this.currentModifiedInteractive) {
              this.currentConfig = {
                type: "report",
                id: powerBiSettingsResults.reportId,
                embedUrl: powerBiSettingsResults.embedUrl,
                accessToken: powerBiSettingsResults.accessToken,
                permissions: PbiModels.Permissions.ReadWrite,
                viewMode: PbiModels.ViewMode.Edit,
                settings: {
                  navContentPaneEnabled: true,
                  //bookmarksPaneEnabled: true,
                  bars: {
                    actionBar: {
                      visible: false,
                    },
                  },
                },
              };

              this.embeddedReport = this.powerBiClientService.embed(
                this.pbiContainer.nativeElement,
                this.currentConfig
              ) as PbiReport;

              this.app.pushLoading("Loading Interactive");

              this.loadServices();

              this.embeddedReport.on(
                "pageChanged",
                (parameters: CustomEvent) => {
                  const newPage = parameters.detail.newPage;

                  this.interactiveService.interactivesLogNavigatedToInteractivePage({
                    interactiveId: this.currentInteractive ? parseInt(this.interactId) : undefined,
                    modifiedInteractiveId: this.currentModifiedInteractive ? parseInt(this.interactId) : undefined,
                    interactivePage: newPage.name + " : " + newPage.displayName
                  }).subscribe(_ => {
                  })
                });


              this.embeddedReport.on("saved", (_) => {
                this.reportSaved();
              });

              this.embeddedReport.on("rendered", (_) => {
                if (this.firstLoad) {
                  window.setTimeout(() => {
                    this.filterService.applyIfFilter(this.filterId);
                    this.bookmarkService.applyIfBookmark(this.bookmarkId);
                    this.app.popLoading();
                  }, 1000);
                  this.firstLoad = false;
                }
              });
            }
          }
        },
        (_) => {
        }
      );
    });
  }

  getInteractiveConfig(powerBiSettingsResults: PowerBISettings): Promise<any> {
    var preFilterService = this.preFilterService;
    var preFilterValuesService = this.preFilterValueService;
    var preFilterId = "-1";
    var generatePreFilterValues = this.generatePreFilterValuesV2;
    var currentInteractive = this.currentInteractive;

    if (this.currentInteractive.preFilters.length > 0) {
      preFilterId = this.currentInteractive.preFilters.find(x => x.isDefault).preFilterId.toString();
    }

    var basicPreFilter = {
      type: "report",
      id: powerBiSettingsResults.reportId,
      embedUrl: powerBiSettingsResults.embedUrl,
      accessToken: powerBiSettingsResults.accessToken,
      settings: {
        navContentPaneEnabled: true,
        //bookmarksPaneEnabled: true,
        panes: {
          pageNavigation: {},
        },
        bars: {
          actionBar: {
            visible: false,
          },
        },
      },
    };

    return new Promise<any>((resolve, error) => {
      this.globalSettings.settingsGetSideNavigation().subscribe(isEnabled => {
        this.isSideNavigationEnabled = isEnabled;
        let sideNav = {
        };

        if (this.isSideNavigationEnabled) {
          sideNav = {
            visible: true,
            position: 1
          }
        }
        if (preFilterId === "-1") {
          basicPreFilter.settings.panes.pageNavigation = sideNav;
          resolve(basicPreFilter);
        } else {
          this.regionStateValues = preFilterValuesService.getRegionValues();
          this.industryValues = preFilterValuesService.getIndustryValues();
          this.occupationValues = preFilterValuesService.getOccupationValues();

          preFilterService.preFilterGetPreFilterById(+preFilterId).subscribe(result => {
              generatePreFilterValues(result, currentInteractive, preFilterService).then((config) => {
                this.preFilterValues = config;
                resolve({
                  type: "report",
                  id: powerBiSettingsResults.reportId,
                  embedUrl: powerBiSettingsResults.embedUrl,
                  accessToken: powerBiSettingsResults.accessToken,
                  filters: this.preFilterValues,
                  settings: {
                    navContentPaneEnabled: true,
                    //bookmarksPaneEnabled: true,
                    panes: {
                      pageNavigation: sideNav
                    },
                    bars: {
                      actionBar: {
                        visible: false,
                      },
                    },
                  },
                });
              });
              /*this.preFilterValues = generatePreFilterValues(result, currentInteractive, this.regionStateValues, this.industryValues, this.occupationValues, preFilterValuesService);
                resolve({
                  type: "report",
                  id: powerBiSettingsResults.reportId,
                  embedUrl: powerBiSettingsResults.embedUrl,
                  accessToken: powerBiSettingsResults.accessToken,
                  filters: this.preFilterValues,
                  settings: {
                    navContentPaneEnabled: true,
                    //bookmarksPaneEnabled: true,
                    bars: {
                      actionBar: {
                        visible: false,
                      },
                    },
                  },
                });*/
            },
            error => {
              resolve(basicPreFilter);
            });
        }
      });
    });
  }

  getFiltersValue(filters: UdPreFilteredInteractiveFilters[]): string[] {
    let resultValues = [];

    filters.forEach(x => {
      resultValues.push(x.filterValue);
    });

    return resultValues;
  }


  applyPreFilter(preFilterId: number): boolean {
    var preFilterService = this.preFilterService;
    var currentInteractive = this.currentInteractive;
    var generatePreFilterValues = this.generatePreFilterValuesV2;
    var embeddedReport = this.embeddedReport;

    this.preFilterService.preFilterGetPreFilterById(preFilterId).subscribe(result => {
      generatePreFilterValues(result, currentInteractive, preFilterService).then(filterData => {
        embeddedReport.setFilters(filterData);
      });
    });

    return false;
  }


  async generatePreFilterValuesV2(preFilter: US_PreFilter, currentInteractive: US_Interactive, preFilterService: PreFilterService): Promise<any[]> {
    var resultFilters = [];

    var preFilterExpandedDetails = await preFilterService.preFilterGetPreFilterExpandedDetails(preFilter.preFilterId).toPromise();

    var titles: string[] = preFilterExpandedDetails.titles;
    var fuzzyTitles: string[] = preFilterExpandedDetails.fuzzyTitles;
    var organizations: string[] = preFilterExpandedDetails.organizations;
    var fuzzyOrganizations: string[] = preFilterExpandedDetails.fuzzyOrganizations;
    var stateCbsas: string[] = preFilterExpandedDetails.metroAreaIds;
    var industryIndustryIds: string[] = preFilterExpandedDetails.nationalIndustryIds;
    var occupationSocCodes: string[] = preFilterExpandedDetails.occupationSocCodes;

    if (currentInteractive.preFilterTitleAvailable && (titles.length > 0 || fuzzyTitles.length > 0)) {
      // 'Clean Job Titles[Clean Title]

      var logicalOperator = "Or";

      if (preFilter.titlesFuzzyAnd) {
        logicalOperator = "And";
      }

      var conditions = titles.map((x) => ({ operator: "Contains", value: x }));

      fuzzyTitles.forEach(x => {
        conditions.push({ operator: 'Contains', value: x });
      });

      resultFilters.push({
        $schema: "http://powerbi.com/product/schema#advanced",
        target: {
          table: "Job Titles",
          column: "Job Title"
        },
        logicalOperator: logicalOperator,
        conditions: conditions,
        filterType: 0, // Advanced Filter
        displaySettings: {
          isHiddenInViewMode: false
        }
      });

    }

    if (currentInteractive.preFilterCompanyAvailable && (organizations.length > 0 || fuzzyOrganizations.length > 0)) {
      // 'Organizations'[Name]

      var logicalOperator = "Or";

      if (preFilter.companiesFuzzyAnd) {
        logicalOperator = "And";
      }

      var conditions = organizations.map((x) => ({ operator: "Is", value: x }));

      fuzzyOrganizations.forEach(x => {
        conditions.push({ operator: 'Contains', value: x });
      });

      resultFilters.push({
        $schema: "http://powerbi.com/product/schema#advanced",
        target: {
          table: "Organizations",
          column: "Name"
        },
        logicalOperator: logicalOperator,
        conditions: conditions,
        filterType: 0, // Advanced Filter
        displaySettings: {
          isHiddenInViewMode: false
        }
      });

    }

    if (currentInteractive.preFilterOccupationAvailable && occupationSocCodes.length > 0) {
      // 'Occupations (SOC)'[O*NET SOC Code]

      resultFilters.push({
        $schema: 'http://powerbi.com/product/schema#basic',
        filterType: 1, // Basic Filter Type
        operator: 'In',
        target: {
          table: 'Occupations',
          column: 'ONET Code'
        },
        values: occupationSocCodes,
        displaySettings: {
          isHiddenInViewMode: false
        }
      });

    }

    if (currentInteractive.preFilterIndustryAvailable && industryIndustryIds.length > 0) {
      // 'Industries (NAICS)'[National Industry ID]

      var conditions = industryIndustryIds.map((x) => ({ operator: "Contains", value: x }));

      resultFilters.push({
        $schema: 'http://powerbi.com/product/schema#basic',
        target: {
          table: 'Linkedin Industries',
          column: 'Subindustry'
        },
        logicalOperator: 'Or',
        conditions: conditions,
        fiterType: 0,
        displaySettings: {
          isHiddenInViewMode: false
        }
      });

    }

    if (currentInteractive.preFilterRegionAvailable && stateCbsas.length > 0) {
      // 'Regions'[Metro Area ID (CBSA)]

      var conditions = stateCbsas.map((x) => ({ operator: "Contains", value: x }));

      resultFilters.push({
        $schema: 'http://powerbi.com/product/schema#basic',
        target: {
          table: 'Regions',
          column: 'Metro (CBSA)'
        },
        logicalOperator: 'Or',
        conditions: conditions,
        filterType: 0, // Advanced Filter
        displaySettings: {
          isHiddenInViewMode: false
        }
      });

    }

    return resultFilters;
  }

  /*
  generatePreFilterValues(preFilter: US_PreFilter, currentInteractive: US_Interactive, regions: PfkRegionState[], industries: PfkIndustrySector[], occupations: PfkOccupationMajorGroup[], preFilterValueService: PreFilterValuesService): any[] {
    var resultFilters = [];

    var titles: string[] = [];
    var fuzzyTitles: string[] = [];
    var companies: string[] = [];
    var fuzzyCompanies: string[] = [];
    var stateIds: string[] = [];
    var stateCbsas: string[] = [];
    var industrySectorIds: string[] = [];
    var industryIndustryIds: string[] = [];
    var occupationMajorGroupIds: string[] = [];
    var occupationMinorGroupIds: string[] = [];
    var occupationBroadGroupIds: string[] = [];
    var occupationDetailIds: string[] = [];
    var occupationSocCodes: string[] = [];

    preFilter.preFilterValues.forEach(preFilterValue => {
      switch(preFilterValue.valueType) {
        case 0: titles.push(preFilterValue.value); break;                     // Title
        case 1: companies.push(preFilterValue.value); break;                  // Company
        case 2: stateIds.push(preFilterValue.value); break;                   // Region - State
        case 3: stateCbsas.push(preFilterValue.value); break;                 // Region - CBSA
        case 4: industrySectorIds.push(preFilterValue.value); break;          // Industry - Sector
        case 5: industryIndustryIds.push(preFilterValue.value); break;         // Industry - Sub Sector
        case 6: occupationMajorGroupIds.push(preFilterValue.value); break;    // Occupation - Major Group
        case 7: occupationMinorGroupIds.push(preFilterValue.value); break;    // Occupation - Minor Group
        case 8: occupationBroadGroupIds.push(preFilterValue.value); break;   // Occupation - Broad Group
        case 9: occupationDetailIds.push(preFilterValue.value); break;         // Occupation - Details
        case 10: occupationSocCodes.push(preFilterValue.value); break;        // Occupation - ONET Soc Code
        case 11: fuzzyTitles.push(preFilterValue.value); break;               // Title Fuzzy Search
        case 12: fuzzyCompanies.push(preFilterValue.value); break;            // Company Fuzzy Search
      }
    });

    //Grab all the lowest level items ONLY

    occupations.forEach(majorGroup => {
      if (occupationMajorGroupIds.find(x => x === majorGroup.majorGroupId)) {
        majorGroup.minorGroups.forEach(minorGroup => {
          minorGroup.broadGroups.forEach(broadGroup => {
            broadGroup.occupationDetails.forEach(details => {
              details.occupationOnets.forEach(onet => {
                occupationSocCodes.push(onet.onetOccupation);
              });
            });
          });
        });
      } else {
        majorGroup.minorGroups.forEach(minorGroup => {
          if (occupationMinorGroupIds.find(x => x === minorGroup.minorGroupId)) {
            minorGroup.broadGroups.forEach(broadGroup => {
              broadGroup.occupationDetails.forEach(details => {
                details.occupationOnets.forEach(onet => {
                  occupationSocCodes.push(onet.onetOccupation);
                });
              });
            });
          } else {
            minorGroup.broadGroups.forEach(broadGroup => {
              if (occupationBroadGroupIds.find(x => x === broadGroup.broadGroupId)) {
                broadGroup.occupationDetails.forEach(details => {
                  details.occupationOnets.forEach(onet => {
                    occupationSocCodes.push(onet.onetOccupation);
                  });
                });
              } else {
                broadGroup.occupationDetails.forEach(details => {
                  if (occupationDetailIds.find(x => x === details.detailId)) {
                    details.occupationOnets.forEach(onet => {
                      occupationSocCodes.push(onet.onetOccupation);
                    });
                  }
                });
              }
            });
          }
        });
      }
    });

    industries.forEach(sector => {
      if (industrySectorIds.find(x => x === sector.sectorId.toString())) {
        sector.industries.forEach(industry => {
          industryIndustryIds.push(industry.industryId.toString());
        });
      }
    });

    regions.forEach(state => {
      if (stateIds.find(x => x === state.state)) {
        state.metroAreas.forEach(metroArea => {
          stateCbsas.push(metroArea.metroArea.replace(',', '').replace(' Metro Area', '').replace(' Micro Area', ''));
        });
      }
    });


    if (currentInteractive.preFilterTitleAvailable && (titles.length > 0 || fuzzyTitles.length > 0)) {
      // 'Clean Job Titles[Clean Title]

      var logicalOperator = "Or";

      if (preFilter.titlesFuzzyAnd) {
        logicalOperator = "And";
      }

      var conditions = titles.map((x) => ({ operator: "Contains", value: preFilterValueService.getTitleValueById(x).title ?? x }));

      fuzzyTitles.forEach(x => {
        conditions.push({ operator: 'Contains', value: x });
      });

      resultFilters.push({
        $schema: "http://powerbi.com/product/schema#advanced",
        target: {
          table: "Job Titles",
          column: "Job Title"
        },
        logicalOperator: logicalOperator,
        conditions: conditions,
        filterType: 0, // Advanced Filter
        displaySettings: {
          isHiddenInViewMode: false
        }
      });

    }

    if (currentInteractive.preFilterCompanyAvailable && (companies.length > 0 || fuzzyCompanies.length > 0)) {
      // 'Company Profiles'[Company Name]

      var logicalOperator = "Or";

      if (preFilter.companiesFuzzyAnd) {
        logicalOperator = "And";
      }

      var conditions = companies.map((x) => ({ operator: "Contains", value: preFilterValueService.getCompanyValueById(x).company ?? x }));

      fuzzyCompanies.forEach(x => {
        conditions.push({ operator: 'Contains', value: x });
      });

      resultFilters.push({
        $schema: "http://powerbi.com/product/schema#advanced",
        target: {
          table: "Companies",
          column: "Company"
        },
        logicalOperator: logicalOperator,
        conditions: conditions,
        filterType: 0, // Advanced Filter
        displaySettings: {
          isHiddenInViewMode: false
        }
      });

    }

    if (currentInteractive.preFilterOccupationAvailable && occupationSocCodes.length > 0) {
      // 'Occupations (SOC)'[O*NET SOC Code]

      resultFilters.push({
        $schema: 'http://powerbi.com/product/schema#basic',
        filterType: 1, // Basic Filter Type
        operator: 'In',
        target: {
          table: 'Occupations',
          column: 'ONET Code'
        },
        values: occupationSocCodes,
        displaySettings: {
          isHiddenInViewMode: false
        }
      });

    }

    if (currentInteractive.preFilterIndustryAvailable && industryIndustryIds.length > 0) {
      // 'Industries (NAICS)'[National Industry ID]

      resultFilters.push({
        $schema: 'http://powerbi.com/product/schema#basic',
        filterType: 1, // Basic Filter Type
        operator: 'In',
        target: {
          table: 'Industries (NAICS)',
          column: 'NAICS ID'
        },
        values: industryIndustryIds.map(x => +x),
        displaySettings: {
          isHiddenInViewMode: false
        }
      });

    }

    if (currentInteractive.preFilterRegionAvailable && stateCbsas.length > 0) {
      // 'Regions'[Metro Area ID (CBSA)]

      resultFilters.push({
        $schema: 'http://powerbi.com/product/schema#basic',
        filterType: 1, // Basic Filter Type
        operator: 'In',
        target: {
          table: 'Regions',
          column: 'CBSA Code'
        },
        values: stateCbsas.map(x => +x),
        displaySettings: {
          isHiddenInViewMode: false
        }
      });

    }

    return resultFilters;
  }*/

  /*
  generatePreFilter(): any[] {
    let combinedFilters: UdPreFilteredInteractiveFilters[][] = [];

    this.currentPreFilteredInteractive.filters.forEach(filter => {
      let wasFound = false;

      for(let i = 0; i < combinedFilters.length; i++) {
        if(combinedFilters[i][0].filterDax === filter.filterDax) {
          wasFound = true;
          combinedFilters[i].push(filter);
        }
      }

      if (!wasFound) {
        combinedFilters.push([]);
        combinedFilters[combinedFilters.length - 1].push(filter);
      }
    });

    let resultFilters = [];

    //Dax comes in like this:
    // 'table name'[column name]

    combinedFilters.forEach(filters => {
      let daxParts = filters[0].filterDax
        .replace("'", "")
        .replace("'", "")
        .replace("]", "")
        .split("[");

      //Using IBasicFilter
      resultFilters.push({
        $schema: '',
        filterType: 1, // Basic Filter Type
        operator: "In",
        target: {
          table: daxParts[0],
          column: daxParts[1]
        },
        values: this.getFiltersValue(filters),
        displaySettings: {
          isHiddenInViewMode: true
        }
      })
    })

    return resultFilters;
  }*/

  loadServices(): void {
    this.filterService = new FilterService(
      this.userId,
      this.userState,
      this.dialog,
      this.app,
      this.refreshUserState,
      this.subscriptionService,
      this.currentInteractive ? this.interactId : undefined,
      this.currentModifiedInteractive ? this.interactId : undefined,
      this.currentInteractive,
      this.currentModifiedInteractive,
      this.embeddedReport,
      this.interactiveService
    );

    this.bookmarkService = new BookmarkService(
      this.userId,
      this.userState,
      this.dialog,
      this.app,
      this.refreshUserState,
      this.subscriptionService,
      this.currentInteractive ? this.interactId : undefined,
      this.currentModifiedInteractive ? this.interactId : undefined,
      this.currentInteractive,
      this.currentModifiedInteractive,
      this.embeddedReport,
      this.interactiveService
    );

    this.reportService = new ReportService(
      this.userId,
      this.userState,
      this.dialog,
      this.app,
      this.refreshUserState,
      this.subscriptionService,
      this.currentInteractive ? this.interactId : undefined,
      this.currentInteractive,
      this.embeddedReport,
      this.interactiveService,
      this.router
    );

    this.filterService.loadFilters();
    this.bookmarkService.loadBookmarks();
    this.reportService.loadReports();
    this.reportService.loadReportExports();
  }

  refreshUserState(): Promise<UserState> {
    const subscriptionService = this.subscriptionService;
    return new Promise<UserState>((resolve, error) => {
      subscriptionService.subscriptionGetUserSubscriptionState().subscribe(result => {
        this.userState = result;
        this.app.setUserState(result);
        resolve(result);
      });
    });
  }

  /*refreshUserState = () =>
    this.subscriptionService.subscriptionGetUserSubscriptionState().toPromise();*/

  setUserState(userState: UserState): void {
    this.userState = userState;
    this.app.setUserState(userState);
  }

  loadUserState(): number {
    let interactiveId = -1;

    if (this.interactType === "ModifiedInteractive") {
      this.currentInteractive = null;
      //this.currentPreFilteredInteractive = null;
      this.currentModifiedInteractive = this.userState.modifiedInteractives.find(
        (x) => x.modInteractId.toString() === this.interactId
      );
      interactiveId = this.currentModifiedInteractive.modInteractId;
    } else if (this.interactType === "Interactive") {
      this.currentModifiedInteractive = null;
      //this.currentPreFilteredInteractive = null;
      this.currentInteractive = this.userState.interactives.find(
        (x) => x.interactId.toString() === this.interactId
      );
      interactiveId = this.currentInteractive.interactId;
    } /*else if (this.interactType === "PreFilteredInteractive") {
      this.currentModifiedInteractive = null;
      this.currentPreFilteredInteractive = this.userState.preFilteredInteractives.find(
        x => x.preFilteredInteractiveId.toString() === this.interactId
      );
      this.currentInteractive = this.userState.interactives.find(
        (x) => x.interactId === this.currentPreFilteredInteractive.interactId
      );
      interactiveId = this.currentPreFilteredInteractive.preFilteredInteractiveId;
    }*/

    return interactiveId;
  }

  reportSaved() {
    this.reportSaving = false;
    if (!this.doingSaveAs) {
      MessageDialogComponent.showDialog(
        this.dialog,
        "Success",
        "Interactive Saved"
      );
    } else {
      this.doingSaveAs = false;
      this.finishSaveAs();
    }
  }

  save(): boolean {
    this.embeddedReport.save();
    this.reportSaving = true;
    return false;
  }

  finishSaveAs() {
    const dialogData: CopyInteractiveDialogData = {
      dialogTitle: "Save As",
      name: this.currentModifiedInteractive.name,
      isOwner: true,
      userSubscriptions: this.currentModifiedInteractive.subscriptionHeaders,
      shareState: UserStateEx.getModifiedInteractiveShareState(this.userState, this.currentModifiedInteractive)
    };

    const dialogRef = this.dialog.open(CopyInteractiveDialogComponent, {
      width: "500px",
      data: dialogData,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (
        result !== null &&
        result.ResultType !== null &&
        result.ResultType === DialogResultType.Ok
      ) {
        const params: InteractivesService.InteractivesUpdateInteractiveNameParams = {
          interactiveId: this.currentModifiedInteractive.modInteractId,
          newName: result.ResultData.name,
        };

        this.interactiveService
          .interactivesUpdateInteractiveName(params)
          .subscribe(
            (result) => {
              if (result) {
                this.loadUserState();
              }
            },
            (_) => {}
          );

        this.interactiveService
          .interactivesUpdateInteractiveSharing({
            interactiveId: this.currentModifiedInteractive.modInteractId,
            updateSharingStatus: UserStateEx.getSharingStatus(
              result.ResultData.shareState
            ),
          })
      }
    });
  }

  saveAs(): boolean {
    this.embeddedReport.isSaved().then((isSaved) => {
      if (isSaved) {
        this.finishSaveAs();
      } else {
        ConfirmDialogComponent.showDialog(
          this.dialog,
          "Report Needs Saved",
          "Report must be saved before save as can be used, save now?"
        ).subscribe((result) => {
          if (result.ResultType == DialogResultType.Ok) {
            this.doingSaveAs = true;
            this.save();
          }
        });
      }
    });

    return false;
  }

  showMenu(): boolean {
    let dialogData: InteractMenuDialogData = {
      modInteractve: this.currentModifiedInteractive !== null,
      selectedAction: "",
      isOwner: this.currentModifiedInteractive?.owner,
    };

    const dialogRef = this.dialog.open(InteractMenuDialogComponent, {
      width: "600px",
      height: "375px",
      data: dialogData,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (
        result && result.ResultType !== null &&
        result.ResultType === DialogResultType.Ok
      ) {
        dialogData = result.ResultData as InteractMenuDialogData;

        switch (dialogData.selectedAction) {
          case "save":
            this.save();
            break;
          case "saveAs":
            this.saveAs();
            break;
          case "updateSharing":
            this.updateSharing();
            break;
        }
      }
    });

    return false;
  }

  updateSharing(): boolean {
    const dialogData: ShareInteractiveDialogData = {
      userSubscriptions: this.currentModifiedInteractive.subscriptionHeaders,
      shareState: UserStateEx.getModifiedInteractiveShareState(
        this.userState,
        this.currentModifiedInteractive
      ),
    };

    const dialogRef = this.dialog.open(ShareInteractiveDialogComponent, {
      width: "500px",
      data: dialogData,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (
        result !== null &&
        result.ResultType !== null &&
        result.ResultType === DialogResultType.Ok
      ) {
        const ResultData = result.ResultData as ShareInteractiveDialogData;
        const sharingStatus = UserStateEx.getSharingStatus(
          ResultData.shareState
        );
        this.app.pushLoading("Saving Interactive");
        this.interactiveService
          .interactivesUpdateInteractiveSharing({
            interactiveId: this.currentModifiedInteractive.modInteractId,
            updateSharingStatus: sharingStatus,
          })
          .subscribe((_) => {
            this.loadUserState();
            this.app.popLoading();
          });
      }
    });

    return false;
  }

  public loadInteractives(): void {
    this.availableInteractives = [];
    for (let i = 0; i < this.userState.interactives.length; i++) {
      let isAvailable = false;
      for (
        let e = 0;
        e < this.userState.interactives[i].subscriptionHeaders.length;
        e++
      ) {
        if (
          this.userState.interactives[i].subscriptionHeaders[e].userType !==
          UserTypeValue.NoRole
        ) {
          isAvailable = true;
        }
      }

      if (isAvailable) {
        this.availableInteractives.push(this.userState.interactives[i]);
      }
    }

    this.availableModifiedInteractives = [];
    for (let i = 0; i < this.userState.modifiedInteractives.length; i++) {
      let isAvailable = false;
      for (
        let e = 0;
        e < this.userState.modifiedInteractives[i].subscriptionHeaders.length;
        e++
      ) {
        if (
          this.userState.modifiedInteractives[i].subscriptionHeaders[e]
            .userType !== UserTypeValue.NoRole
        ) {
          isAvailable = true;
        }
      }

      if (isAvailable) {
        this.availableModifiedInteractives.push(
          this.userState.modifiedInteractives[i]
        );
      }
    }

    /*this.availablePreFilteredInteractives = [];
    for (let i = 0; i < this.userState.preFilteredInteractives.length; i++) {
      let isAvailable = false;
      for (
        let e = 0;
        e < this.userState.preFilteredInteractives[i].subscriptionHeaders.length;
        e++
      ) {
        if (
          this.userState.preFilteredInteractives[i].subscriptionHeaders[e]
            .userType !== UserTypeValue.NoRole
        ) {
          isAvailable = true;
        }
      }

      if (isAvailable) {
        this.availablePreFilteredInteractives.push(
          this.userState.preFilteredInteractives[i]
        );
      }
    }*/
  }

  interactiveView(interactive: US_Interactive): boolean {
    const queryStringParams = {
      interactId: interactive.interactId.toString(),
      interactType: "Interactive",
      actionType: "view",
      filterId: "-1",
      bookmarkId: "-1",
      reportId: "-1",
    };

    this.router.navigate([
      "powerbi-embedded",
      queryStringParams.interactId,
      queryStringParams.interactType,
      queryStringParams.actionType,
      queryStringParams.filterId,
      queryStringParams.bookmarkId,
      queryStringParams.reportId,
    ]);

    return false;
  }

  modifiedInteractiveView(interactive: US_ModifiedInteractive): boolean {
    const queryStringParams = {
      interactId: interactive.modInteractId.toString(),
      interactType: "ModifiedInteractive",
      actionType: "view",
      filterId: "-1",
      bookmarkId: "-1",
      reportId: "-1",
    };

    this.router.navigate([
      "powerbi-embedded",
      queryStringParams.interactId,
      queryStringParams.interactType,
      queryStringParams.actionType,
      queryStringParams.filterId,
      queryStringParams.bookmarkId,
      queryStringParams.reportId,
    ]);

    return false;
  }

  interactiveCopyAndEdit(interactive: US_Interactive): boolean {
    const dialogData: CopyInteractiveDialogData = {
      dialogTitle: "Copy & Edit Interactive",
      name: "",
      shareState: UserStateEx.getModifiedInteractiveShareState(this.userState,  {
        allowEdit: true,
        shares: [],
        modInteractId: 0,
        subscriptionHeaders: [],
        interactive: undefined,
        bookmarks: [],
        interactId: 0,
        name: '',
        owner: true,
        createdBy: undefined,
        modifiedTimeStamp: undefined,
        powerBidatasetId: undefined,
        userId: 0,
        subscriptionId: 0,
        deleted: false
      }),
      userSubscriptions: interactive.subscriptionHeaders,
      isOwner: true
    };

    const dialogRef = this.dialog.open(CopyInteractiveDialogComponent, {
      width: "500px",
      data: dialogData,
    });

    dialogRef.afterClosed().subscribe((dialogResult) => {
      if (
        dialogResult != null &&
        dialogResult.ResultType != null &&
        dialogResult.ResultType == DialogResultType.Ok
      ) {
        const params: InteractivesService.InteractivesDuplicateInteractiveParams = {
          interactiveId: interactive.interactId,
          newName: dialogResult.ResultData.name,
        };

        this.interactiveService
          .interactivesDuplicateInteractive(params)
          .subscribe(
            (result) => {

              this.interactiveService
                .interactivesUpdateInteractiveSharing({
                  interactiveId: result.properties.ModifiedInteractiveId,
                  updateSharingStatus: UserStateEx.getSharingStatus(
                    dialogResult.ResultData.shareState
                  ),
                })
                .subscribe(nextResult => {
                  const queryStringParams = {
                    modInteractId: result.properties.ModifiedInteractiveId,
                    interactType: "ModifiedInteractive",
                    actionType: "edit",
                    filterId: "-1",
                    bookmarkId: "-1",
                    reportId: "-1",
                  };

                  this.router.navigate([
                    "powerbi-embedded",
                    queryStringParams.modInteractId,
                    queryStringParams.interactType,
                    queryStringParams.actionType,
                    queryStringParams.filterId,
                    queryStringParams.bookmarkId,
                    queryStringParams.reportId,
                  ]);
                })
              return false;
            },
            (error) => {
              var e = 0;
            }
          );
      }
    });

    return false;
  }

  modifiedInteractiveEdit(interactive: US_ModifiedInteractive) {
    const queryStringParams = {
      interactId: interactive.modInteractId.toString(),
      interactType: "ModifiedInteractive",
      actionType: "edit",
      filterId: "-1",
      bookmarkId: "1",
      reportId: "-1",
    };

    this.router.navigate([
      "powerbi-embedded",
      queryStringParams.interactId,
      queryStringParams.interactType,
      queryStringParams.actionType,
      queryStringParams.filterId,
      queryStringParams.bookmarkId,
      queryStringParams.reportId,
    ]);

    return false;
  }

  modifiedInteractiveDelete(interactive: US_ModifiedInteractive): boolean {
    const dialogData: ConfirmDialogData = {
      title: "Confirm Delete",
      prompt:
        "Are you sure you want to delete interactive '" +
        interactive.name +
        "'?",
    };

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: "500px",
      data: dialogData,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (
        result !== null &&
        result.ResultType !== null &&
        result.ResultType === DialogResultType.Ok
      ) {
        this.interactiveService
          .interactivesDeleteInteractive(interactive.modInteractId)
          .subscribe(
            (result) => {
              this.loadUserState();

              return false;
            },
            (error) => {}
          );
      }
    });

    return false;
  }

  preFilterInteractiveView(interactive: US_PreFilterInteractives) {
    const queryStringParams = {
      interactId: interactive.preFilteredInteractiveId.toString(),
      interactType: "PreFilteredInteractive",
      actionType: "view",
      filterId: "-1",
      bookmarkId: "-1",
      reportId: "-1",
    };

    this.router.navigate([
      "powerbi-embedded",
      queryStringParams.interactId,
      queryStringParams.interactType,
      queryStringParams.actionType,
      queryStringParams.filterId,
      queryStringParams.bookmarkId,
      queryStringParams.reportId,
    ]);
    return false;
  }

  preFilteredInteractiveCreate(interactive: US_Interactive): boolean {
    this.router.navigate(["edit-interactive-prefilter", interactive.interactId, 0]);
    return false;
  }

  preFilterInteractiveEdit(interactive: US_PreFilterInteractives) {
    this.router.navigate(["edit-interactive-prefilter", interactive.interactId, interactive.preFilteredInteractiveId]);
    return false;
  }

  preFilterInteractiveDelete(interactive: US_PreFilterInteractives) {
    const dialogData: ConfirmDialogData = {
      title: "Confirm Delete",
      prompt:
        "Are you sure you want to delete interactive '" +
        interactive.name +
        "'?",
    };

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: "500px",
      data: dialogData,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (
        result !== null &&
        result.ResultType !== null &&
        result.ResultType === DialogResultType.Ok
      ) {
        this.preFilterInteractiveService
          .preFilterInteractivesDeletePreFilterInteractive(interactive.preFilteredInteractiveId)
          .subscribe(
            (result) => {
              this.loadUserState();

              return false;
            },
            (error) => {}
          );
      }
    });
    return false;
  }

  public closeLinkClicked(): boolean {
    this.closeClicked.next();
    return false;
  }

  public returnFalse(): boolean {
    return false;
  }

  //#region Print Layout

  public podLayout: PodLayoutEx | undefined;

  createLayoutSelected() {
    this.createLayout().then(_ => {});
    return false;
  }

  async createLayout() {
    let newLayout : PodLayoutEx = {
      podLayoutId: 0,
      name: "New Print Layout",
      bookmarkData: undefined,
      bookmarkId: undefined,
      interactId: +this.interactId,
      pages: [],
      subscriptionId: 0,
      userId: this.userId,
      fileTypeId: 0,
      deleted: false,
      isOwner: true,
      allowEditing: true
    };

    await this.editLayout(newLayout);
  }

  editCurrentLayout() {
    if (this.podLayout) {
      this.editLayout(this.podLayout).then(_ => {});
    }
    return false;
  }

  async editLayout(layout: PodLayoutEx) {
    await this.showPodLayoutDialog(layout);
  }

  async showPodLayoutDialog(layout: PodLayoutEx) {
    const result = await PrintOnDemandLayoutDialogComponent.showDialog(
      this.dialog,
      layout,
      this.bookmarkService.interactBookmarks,
      this.availablePrintPages,
      this.currentInteractive.subscriptionHeaders,
      UserStateEx.getPodLayoutShareState(this.userState, layout),
      layout.isOwner
    ).toPromise();

    layout = result.ResultData.podLayout;
    await this.previewLayout(layout, result.ResultData.shareState);
  }

  async previewLayout(layout: PodLayoutEx, shareState: ShareState) {
    await this.printPreviewBegin(layout.pages.map(x => this.availablePrintPages.find(y => y.interactPoDPageId == x.interactPoDPageId)), layout.bookmarkData ?? layout.bookmarkId, shareState,
      () => { // Save
        this.saveLayout({podLayout: layout, shareState: shareState});
        this.printPreviewEnd();
      },
      () => { // Cancel
        this.printPreviewEnd();
        this.editLayout(layout);
      },
      async () => { // Print
        await this.saveLayout({podLayout: layout, shareState: shareState});
        this.submitPrintOnDemand(layout.pages.map(x => this.availablePrintPages.find(y => y.interactPoDPageId == x.interactPoDPageId)), layout.fileTypeId, layout.bookmarkData ?? layout.bookmarkId);
        this.printPreviewEnd();
      });
  }

  async saveLayout(results: PrintOnDemandLayoutDialogResult) {
    let bookmarkData = undefined;

    if (!results.podLayout.bookmarkId) {
      bookmarkData = await this.bookmarkService.captureBookmarkState();
    }

    results.podLayout.bookmarkData = bookmarkData;

    const reportPages = await this.embeddedReport.getPages();
    const podPages: PodLayoutPage[] = [];

    let hasError = false;
    let errorMessage = '';

    results.podLayout.pages.forEach(x => {
      const sourcePage = this.availablePrintPages.find(y => x.interactPoDPageId === y.interactPoDPageId);
      const pageName: string = sourcePage.page.toLowerCase().trim();
      const pageIndex = reportPages.findIndex(z => z.name.toLowerCase().trim() === pageName || z.displayName.toLowerCase().trim() === pageName);
      if (pageIndex == -1) {
        hasError = true;
        errorMessage = 'Page "' + pageName + '" not found in report.';
      } else {
        podPages.push({
          podLayoutId: 0,
          podLayoutPageId: 0,
          interactPoDPageId: x.interactPoDPageId,
          order: x.order,
          pbixPageName: reportPages[pageIndex].name
        });
      }
    });

    if (hasError) {
      alert(errorMessage);
      return;
    }

    results.podLayout.pages = podPages;

    this.app.pushLoading("Saving Layout");
    if (results.podLayout.podLayoutId > 0) {
      const result = await this.printOnDemandService.printOnDemandUpdatePrintOnDemandLayout({printOnDemandLayoutId: results.podLayout.podLayoutId, request: results.podLayout}).toPromise();
      this.podLayout = results.podLayout;
      this.podLayout.podLayoutId = result;
      const sharingResults = await this.printOnDemandService.printOnDemandUpdatePodLayoutSharing({
        podLayoutId: this.podLayout.podLayoutId,
        updateSharingStatus: UserStateEx.getSharingStatus(results.shareState)
      }).toPromise();
      await this.app.refreshUserStateAsync(this.subscriptionService);
      this.app.popLoading();
      this.snackBar.open("Layout '" + results.podLayout.name + "' Updated.", null, {
        duration: 5000
      });
    } else {
      const result = await this.printOnDemandService.printOnDemandCreatePrintOnDemandLayout(results.podLayout).toPromise();
      this.podLayout = results.podLayout;
      const sharingResults = await this.printOnDemandService.printOnDemandUpdatePodLayoutSharing({
        podLayoutId: this.podLayout.podLayoutId,
        updateSharingStatus: UserStateEx.getSharingStatus(results.shareState)
      }).toPromise();
      await this.app.refreshUserStateAsync(this.subscriptionService);
      this.app.popLoading();
      this.snackBar.open("Layout '" + results.podLayout.name + "' Created.", null, {
        duration: 5000
      });
    }
  }

  //#endregion

  //#region Print On Demand

  public printOnDemand_Active: boolean = false;
  public printOnDemand_CurrentFileType: PrintOnDemandFileType = 0;
  public printOnDemand_CurrentPages: InteractPoDPage[] = [];

  async submitPrintOnDemand(printPages: InteractPoDPage[], fileType: PrintOnDemandFileType, bookmarkDataOrId: string | number) {
    if (printPages && printPages.length > 0) {

      const reportPages = await this.embeddedReport.getPages();
      let bookmarkState: string;

      if(typeof bookmarkDataOrId === 'number') {
        bookmarkState = this.bookmarkService.getBookmarkStateById(bookmarkDataOrId);
      } else {
        bookmarkState = await this.bookmarkService.captureBookmarkState();
      }

      const targetPages: string[] = [];
      for (let i = 0; i < printPages.length; i++) {
        const page: string = printPages[i].page.toLowerCase().trim();
        const pageIndex = reportPages.findIndex(x => x.name.toLowerCase().trim() === page || x.displayName.toLowerCase().trim() === page);
        if (pageIndex >= 0) {
          targetPages.push(reportPages[pageIndex].name);
        }
      }

      const statusData: PrintOnDemandData = {
        fileType: this.printOnDemand_CurrentFileType,
        pages: targetPages,
        interactId: parseInt(this.interactId, 10),
        bookmarkJson: bookmarkState
      };

      this.snackBar.openFromComponent(PodStatusSnackbarComponent, {
        data: statusData
      });
    }
  }

  clearPrintOnDemand() {
    this.printOnDemand_CurrentFileType = 0;
    this.printOnDemand_CurrentPages = [];
    this.printOnDemand_Active = false;
  }

  async showPrintOnDemandDialog() {
    const printResults = await PrintOnDemandDialogComponent.showDialog(this.dialog, this.printOnDemand_CurrentFileType, this.availablePrintPages, this.printOnDemand_CurrentPages).toPromise();
    if (printResults.ResultType === DialogResultType.Ok) {

      const results: PrintOnDemandDialogResult = printResults.ResultData;

      this.printOnDemand_CurrentPages = results.selectedPages;
      this.printOnDemand_CurrentFileType = results.fileType;

      await this.printPreview();

    } else {
      this.clearPrintOnDemand();
    }
  }

  async printPreview() {
    const bookmarkData = await this.bookmarkService.captureBookmarkState();
    await this.printPreviewBegin(this.printOnDemand_CurrentPages, bookmarkData, UserStateEx.getPodLayoutShareState(this.userState, undefined),
      undefined,
      async () => { // Cancel
        await this.printPreviewEnd();
        await this.showPrintOnDemandDialog();
      },
      async () => { // Print
        await this.printPreviewEnd(true);
        await this.submitPrintOnDemand(this.printOnDemand_CurrentPages, this.printOnDemand_CurrentFileType, bookmarkData);
      });
  }

  printOnDemand() {
    this.clearPrintOnDemand();

    if (this.podLayout) {
      this.printOnDemand_CurrentPages = this.podLayout.pages.map(x => this.availablePrintPages.find(y => y.interactPoDPageId == x.interactPoDPageId)!);
      this.printOnDemand_CurrentFileType = this.podLayout.fileTypeId;
    }

    this.printOnDemand_Active = true;

    this.showPrintOnDemandDialog();

    return false;
  }

  //#endregion

  //#region Print Preview

  public printPreview_LastPage: string = undefined;
  public printPreview_SelectedPage: InteractPoDPage;
  public printPreview_SelectedPageIndex: number;
  public printPreview_AvailablePages: InteractPoDPage[] = [];
  public printPreview_IsActive: boolean = false;
  public printPreview_ShowSave: boolean = false;
  public printPreview_ShowCancel: boolean = false;
  public printPreview_ShowPrint: boolean = false;
  public printPreview_SaveClicked: () => void | undefined;
  public printPreview_CancelClicked: () => void | undefined;
  public printPreview_PrintClicked: () => void | undefined;

  async printPreviewBegin(previewPages: InteractPoDPage[], bookmarkDataOrId: string | number | undefined, shareState: ShareState, onSave: () => void | undefined, onCancel: () => void | undefined, onPrint: () => void | undefined) {
    if (previewPages && previewPages.length > 0) {

      this.printPreview_SaveClicked = onSave;
      this.printPreview_CancelClicked = onCancel;
      this.printPreview_PrintClicked = onPrint;

      this.printPreview_ShowSave = onSave != undefined;
      this.printPreview_ShowCancel = onCancel != undefined;
      this.printPreview_ShowPrint = onPrint != undefined;

      this.printPreview_AvailablePages = previewPages;
      const activePage = await this.embeddedReport.getActivePage();
      this.printPreview_LastPage = activePage.name;
      this.printPreview_SelectedPage = this.printPreview_AvailablePages[0];
      this.printPreview_SelectedPageIndex = 0;
      this.printPreview_IsActive = true;
      this.printPreviewGoToPage();
    }
  }

  async printPreviewEnd(leaveBookmarkState: boolean = false) {
    await this.embeddedReport.setPage(this.printPreview_LastPage);

    this.printPreview_IsActive = false;
    this.printPreview_LastPage = undefined;
    this.printPreview_SelectedPage = undefined;
    this.printPreview_SelectedPageIndex = 0;
    this.printPreview_AvailablePages = [];
    this.printPreview_SaveClicked = undefined;
    this.printPreview_CancelClicked = undefined;
    this.printPreview_PrintClicked = undefined;
  }

  printPreviewGoToPage() {
    this.embeddedReport.getPages().then(pages => {
      const page: string = this.printPreview_SelectedPage.page.toLowerCase().trim();
      const pageIndex = pages.findIndex(x => x.name.toLowerCase().trim() === page || x.displayName.toLowerCase().trim() === page);
      this.embeddedReport.setPage(pages[pageIndex].name);
    });
  }

  printPreviewPageSelectionChange($event: Event) {
    this.printPreview_SelectedPage = this.printPreview_AvailablePages[this.printPreview_SelectedPageIndex];
    this.printPreviewGoToPage();
    return false;
  }

  printPreviewNextPage(): boolean {
    this.printPreview_SelectedPageIndex++;
    this.printPreview_SelectedPage = this.printPreview_AvailablePages[this.printPreview_SelectedPageIndex];
    this.printPreviewGoToPage();
    return false;
  }

  printPreviewPrevPage(): boolean {
    this.printPreview_SelectedPageIndex--;
    this.printPreview_SelectedPage = this.printPreview_AvailablePages[this.printPreview_SelectedPageIndex];
    this.printPreviewGoToPage();
    return false;
  }

  printPreviewSaveClick(): boolean {
    if (this.printPreview_SaveClicked) {
      this.printPreview_SaveClicked();
    }
    return false;
  }

  printPreviewCancelClick(): boolean {
    if (this.printPreview_CancelClicked) {
      this.printPreview_CancelClicked();
    }
    return false;
  }

  printPreviewPrintClick(): boolean {
    if (this.printPreview_PrintClicked) {
      this.printPreview_PrintClicked();
    }
    return false;
  }

  //#endregion
}
